
<template>
  <div class="relevant">
    <div class="title" :class="globalTransition">{{$t('projectPage.otherProjects.title')}}</div>
    <el-carousel :interval="4000" type="card" height="30rem" class="carousel">
      <el-carousel-item v-for="event in projectsList" :key="event">
        <div class="carousel-item"><img :src="computeSrc(event)" alt="DIMER" class="carousel-img">
          <div class="carousel-title" :class="globalTransition">
            {{$t('projectPage.projectList.'+event+'.name')}}</div>
          <a class="carousel-link" :class="globalTransition">
            {{$t('projectPage.projectList.'+event+'.time')}}</a></div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import tempHeadImg from '@/assets/tempHeadImg.jpg';

export default {
  name: 'otherProjects',
  data() {
    return {
      tempHeadImgUrl: tempHeadImg,
      projectsList: ['project1', 'project2', 'project3', 'project4', 'project5'],
    };
  },
  computed: {
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
  methods: {
    computeSrc(event) {
      // eslint-disable-next-line
      return require(`../../assets/${event}.jpg`);
    },
  },
};
</script>

<style lang="scss" scoped>
  .relevant{
    background-color: #fff;
    padding: 0rem 6.7%;
    .title{
      padding-left: 3%;
      font-size: 3rem;
      font-weight: bold;
      padding-bottom: 4rem;
    }
    .carousel{}
  }
  .carousel-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    .carousel-img{
      margin: 0;
      width: 60%;
    }
    .carousel-title{
      line-height: 2rem;
      font-size: 1.2rem;
      font-weight: bold;
      flex-wrap: wrap;
      width: 60%;
      margin-top: 20px;
    }
    .carousel-link{
      color: #369ff6;
      line-height: 2rem;
      width: 60%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/projectPage/otherProjects.vue